<template>
  <el-breadcrumb separator="/">
    <el-breadcrumb-item :to="{ path: '/course' }">我的课程</el-breadcrumb-item>
    <el-breadcrumb-item :to="{ path: '/course/courselist' }">
      {{ coursename }}
    </el-breadcrumb-item>
    <el-breadcrumb-item :to="{ path: link }">
      {{ $props.name }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
    },
  },
  data() {
    return {
      coursename: '',
      link: '',
    }
  },
  created() {
    this.coursename = this.$store.state.coursename
    this.link = this.$route.fullPath
  },
}
</script>
